'use client';
import { CONSENT_COOKIE_AND_LOCALSTORAGE_KEY, } from '@stepstone/user-consent-events/module/types';
export const getSocialAuthConsent = () => {
    if (window && window.localStorage) {
        const consentLevel = window.localStorage.getItem(CONSENT_COOKIE_AND_LOCALSTORAGE_KEY);
        if (consentLevel) {
            const parsedConsentLevel = JSON.parse(consentLevel);
            return parsedConsentLevel.isFunctional || false;
        }
    }
    return false;
};
//# sourceMappingURL=getSocialAuthConsent.js.map